import Box from "@mui/material/Box";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import TestsmsIcon from "@mui/icons-material/Textsms";
import Button from "designSystem/components/button/Button";
import { grey } from "designSystem/styles/color";
import { Placeholder } from "designSystem/index";
import React from "react";

// For real example refer to src/Chat/slak/component/ConnectToSlackFirstTime.tsx

export default () => (
	<Placeholder
		subtitleMargin={6}
		subtitleProps={{ res: "Streamline communication with your team by connecting to Slack" }}
		titleProps={{ res: "Connect To Slack" }}
	>
		{{
			actions:
				<Button
					design="primary"
					res="Connect Style to Slack Channel"
				/>
			,
			image:
				<Box>
					<Box color={grey[100]} height={36}>
						<ChatBubbleIcon style={{ fontSize: 36, opacity: 0.2 }} />
					</Box>
					<Box
						color={grey[300]}
						height={36}
						ml={9}
					>
						<TestsmsIcon style={{ fontSize: 36, transform: "rotateY(180deg)", opacity: 0.3 }} />
					</Box>
				</Box>
			,
		}}
	</Placeholder>
);
